import { view, bowser } from '@yola/ws-sdk';
import getViewLeftOffset from 'src/js/modules/view/helpers/get-view-left-offset';
import serviceClient from 'yola-editor/src/js/modules/feature-flags/service-client';
import customUI from 'src/js/modules/custom-ui';
import contextMenu from 'src/js/modules/context-menu';
import createPositionCalculator from 'src/js/modules/control-pane/helpers/create-position-calculator';
import constants from '../constants';
import getTextAssistantMenuActions from './get-text-assistant-menu-actions';

const { AI_REWRITE_TEXT_ACTIVE_HEADER_MOBILE_WIDTH, AI_REWRITE_TEXT_ACTIVE_HEADER_WIDTH } =
  constants.common;

const getTextAssistantContextMenuGroups = () => {
  const featureFlagsManager = serviceClient.get();

  return getTextAssistantMenuActions(featureFlagsManager);
};

const showAiRewriteContextMenu = ({
  elementId,
  triggerId,
  getContext,
  focusedElementInfo,
  onHideExceptInsideClick = Function.prototype,
}) => {
  const element = view.accessors.getLiveElement(elementId);
  const { controlPane, aiWriteTriggerRef } = getContext();
  const { position, forceHighlighterRerender } = controlPane;
  const { x } = position;
  const viewLeftOffset = getViewLeftOffset();
  const initialMenuGroups = getTextAssistantContextMenuGroups();

  const aiWriterWidth = bowser.mobile
    ? AI_REWRITE_TEXT_ACTIVE_HEADER_MOBILE_WIDTH
    : AI_REWRITE_TEXT_ACTIVE_HEADER_WIDTH;
  const aiWriterPosition = {
    left: x + viewLeftOffset - aiWriterWidth / 2,
    width: aiWriterWidth,
  };

  const showAiRewriteTool = (additionalProps) =>
    customUI.operations.show(customUI.customUiTypes.AI_REWRITE, {
      elementId,
      triggerId,
      getContext,
      position: aiWriterPosition,
      hideAiWriter: () => customUI.operations.hide(),
      ...additionalProps,
    });

  if (!initialMenuGroups.length) {
    showAiRewriteTool();

    return;
  }

  const handleOnMenuItemClick = (item) => {
    contextMenu.operations.hideContextMenu();

    showAiRewriteTool({
      selectedAiRewriteOption: { value: item.id, label: item.caption },
      focusedElementInfo,
    });
    forceHighlighterRerender();
  };

  const menuGroups = initialMenuGroups.map((menuGroup) => ({
    ...menuGroup,
    element,
    items: menuGroup.items.map((item) => ({
      ...item,
      onClick: (event) => {
        event.stopPropagation();
        handleOnMenuItemClick(item);
      },
    })),
  }));

  contextMenu.operations.showContextMenu({
    position,
    groups: menuGroups,
    triggerId,
    calculatePosition: createPositionCalculator(controlPane, aiWriteTriggerRef),
    onHideExceptInsideClick,
  });
};

const hideAiRewriteContextMenu = () => {
  contextMenu.operations.hideContextMenu();
};

export { showAiRewriteContextMenu, hideAiRewriteContextMenu };
